import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { IconField } from 'primeng/iconfield';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputIcon } from 'primeng/inputicon';
import { InputNumber } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { Select } from 'primeng/select';
import Dealership from '../../../../../../types/dealership/Dealership';
import StudioWriteDTO from '../../../../../../types/studio/StudioWriteDTO';
import { DealershipService } from '../../../../services/dealership.service';
import { StudioService } from '../../../../services/studio.service';

@Component({
    selector: 'app-create-studio-dialog',
    templateUrl: './create-studio-dialog.component.html',
    styleUrls: [ './create-studio-dialog.component.scss' ],
    imports: [
        DialogModule,
        InputTextModule,
        ButtonModule,
        FormsModule,
        IconField,
        InputIcon,
        IftaLabelModule,
        InputNumber,
        Select,
    ]
})
export class CreateStudioDialogComponent implements OnInit {
    @Input() visible: boolean = false;
    @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() studioCreated: EventEmitter<StudioWriteDTO> = new EventEmitter<StudioWriteDTO>();

    constructor(
        private studioService: StudioService,
        private messageService: MessageService,
        private dealershipService: DealershipService
    ) {
    }

    public studio: StudioWriteDTO = new StudioWriteDTO({});
    public availableDealerships: Dealership[] = [];
    public loading = false;
    public loadingDealerships = false;

    public ngOnInit() {
        this.loadDealerships();
    }

    get saveDisabled(): boolean {
        return !this.studio.name || !this.studio.dealershipId;
    }

    public close() {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    public loadDealerships() {
        this.loadingDealerships = true;
        this.dealershipService
            .getAllDealerships()
            .then((dealerships) => {
                this.availableDealerships = dealerships;
            })
            .catch((error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message,
                    life: 3000,
                });
            })
            .finally(() => {
                this.loadingDealerships = false;
            });
    }

    public saveStudio() {
        this.loading = true;

        this.studioService
            .createStudio(this.studio)
            .then(() => {
                this.studioCreated.emit(this.studio);
                this.close();
            })
            .catch((error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message,
                    life: 3000,
                });
            })
            .finally(() => {
                this.studio = new StudioWriteDTO({});
                this.loading = false;
            });
    }
}
